import React from 'react';
import styles from './StudentWelcome.module.css';

function Button({ children, className = '', variant = 'solid', ...props }) {
  const baseStyles = styles.buttonBase;
  const variantStyles = variant === 'outline' ? styles.buttonOutline : styles.buttonSolid;
  
  return (
    <button
      className={`${baseStyles} ${variantStyles} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}

export default Button;
